import { render, staticRenderFns } from "./ListCardsPage.vue?vue&type=template&id=729c9ecc&"
import script from "./ListCardsPage.vue?vue&type=script&lang=js&"
export * from "./ListCardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports